import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { backToOffers } from "containers/MultistepForm/actions";
import { logEvent } from "../../../../EmbeddableWidget/actions";

import "./styles.scss";

class KafenePendingAppScreen extends Component {
  handleBackButton = () => {
    const { backToOffers, logEvent } = this.props;
    backToOffers();
    logEvent({ name: "view other options" });
  };

  render() {
    const { loading } = this.props;

    return (
      <div className="kafene-pending-screen">
        <div className="kafene-pending-screen__icon">
          ⏳
        </div>

        <h1 className="kafene-pending-screen__title">Application Pending</h1>
        
        <p className="kafene-pending-screen__subtitle">
          Customer Action Required
        </p>

        <div className="kafene-pending-screen__info-box">
          <p>
            We will review the information and reply via email about your approval shortly. 
            If it is after 9pm EST, your email decision may arrive tomorrow morning.
          </p>
          <p>
            If you have any questions, please contact us at{' '}
            <a href="tel:+18552064040" className="kafene-pending-screen__phone">
              (855) 206-4040
            </a>.
          </p>
        </div>

        <BlueBtn
          customClass="bank-data-form-submit-btn"
          loading={loading}
          onClick={this.handleBackButton}
        >
          Return to Checkout
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    backToOffers: () => dispatch(backToOffers()),
    logEvent: (value) => dispatch(logEvent(value)),
  };
};

KafenePendingAppScreen = connect(
  mapStateToProps,
  mapDistpatchToProps
)(KafenePendingAppScreen);

export default KafenePendingAppScreen;
